import { useEffect, useMemo } from "react";
import { useSelectedEntity, useRelationshipPanelActive } from "./useSelectedEntity";
import { useConfig } from "../contexts/ConfigContext";
import { useSelectionActions } from "../store/selection";

export function useSyncMapHighlights() {
  const config = useConfig();

  const { entity } = useSelectedEntity();
  const { setSecondaryItems, clearSecondaryItems } = useSelectionActions();
  const relationshipPanelActive = useRelationshipPanelActive();

  // Stabilize: only recompute when the actual content changes, not reference
  const relatedItems = useMemo(() => {
    // Prefer entity.relationships (normalised, new field); fall back to entity.relations (alias)
    const rels = (entity as any)?.relationships ?? entity?.relations;
    if (!rels?.byTableSlug) return null;

    return Object.entries(rels.byTableSlug).flatMap(([slug, values]) => {
      const apiEndPoint = config?.apiEndpoints?.find((ep) => ep.tableName === slug);

      return (values as any[]).map((value) => ({
        id: value.id,
        layerId: apiEndPoint?.mapLayerId ?? ""
      }));
    });
  }, [(entity as any)?.relationships, entity?.relations, config?.apiEndpoints]);

  useEffect(() => {
    if (!relatedItems) {
      clearSecondaryItems();
      return;
    }

    if (relatedItems.length > 0 && relationshipPanelActive) {
      setSecondaryItems(relatedItems, "relationship");
    } else {
      clearSecondaryItems();
    }
  }, [relatedItems, relationshipPanelActive, setSecondaryItems, clearSecondaryItems]);
}
